import React from "react";
import { Box } from "theme-ui";
import camelCase from "lodash/fp/camelCase";
import castArray from "lodash/fp/castArray";

import FormField from "./FormField";
import SubFields from "./SubFields";
import * as styles from "./SkateCustomiseBlade.styles";

export default function Fields({ fields, onChange, fieldsState }) {
  return fields.map(castArray).map((fieldArray, index) => {
    return (
      <Box
        sx={
          styles[camelCase(fieldArray[0].name + "Container")] || styles.formRow
        }
        key={index}
      >
        {fieldArray.map((field) => {
          const options = field.options || [];
          const selectedOption =
            options.find(({ value }) => value === fieldsState[field.name]) ||
            {};

          return (
            <React.Fragment key={field.name}>
              <FormField
                {...field}
                onChange={onChange(field.name)}
                value={fieldsState[field.name]}
              />
              {selectedOption?.fields && (
                <SubFields
                  fields={selectedOption.fields}
                  fieldsState={fieldsState}
                  onChange={onChange}
                />
              )}
            </React.Fragment>
          );
        })}
      </Box>
    );
  });
}
